import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=14120268&"
import script from "./Gateways.vue?vue&type=script&lang=js&"
export * from "./Gateways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\webinane\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14120268')) {
      api.createRecord('14120268', component.options)
    } else {
      api.reload('14120268', component.options)
    }
    module.hot.accept("./Gateways.vue?vue&type=template&id=14120268&", function () {
      api.rerender('14120268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/style-three/Gateways.vue"
export default component.exports